import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import NumberField from 'components/NumberField/NumberField';
import { PROFIT_CENTER_LINKS } from 'constants/formFields';
import { NUMBER_FORMATS } from 'constants/interfaces';

import type { FieldPath } from 'react-hook-form';
import type { TCreateSupplierSchema } from 'utils/validators';
import type ICostFieldsProps from '../interfaces/ICostFieldsProps';
import type INumberFieldValue from '../interfaces/INumberFieldValue';

import styles from '../sass/ProfitCenterLinks.module.scss';

function CostFields({
  control,
  index,
  placeholder,
  companyCurrency,
  onTotalCostChange,
  onPercentChange,
}: ICostFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.formRow}>
      <Controller
        control={control}
        name={`${PROFIT_CENTER_LINKS}.${index}.totalCost` as FieldPath<TCreateSupplierSchema>}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <div className={styles.totalCostContainer}>
            <div className={styles.fieldWithCurrency}>
              <NumberField
                name={name}
                label={t('suppliers.fields.keySuppliers')}
                value={value}
                error={error?.message}
                onChange={(values: INumberFieldValue) => {
                  onChange(values.value);
                  onTotalCostChange(values.value);
                }}
                placeholder={placeholder || t('suppliers.fields.keySuppliers')}
                className={styles.valueInput}
                allowNegative={false}
                hideTextError
                required
              />
              <span className={`${styles.currencyInput} ${error?.message ? styles.errorBorder : ''}`}>
                M
                {' '}
                {companyCurrency}
              </span>
            </div>
            {error?.message ? <span className={styles.errorMessage}>{error.message}</span> : null}
          </div>
        )}
      />

      <Controller
        control={control}
        name={`${PROFIT_CENTER_LINKS}.${index}.percentOfTotalCost` as FieldPath<TCreateSupplierSchema>}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <NumberField
            name={name}
            label={t('suppliers.fields.keySuppliersInPercentage')}
            value={value}
            error={error?.message}
            onChange={(values: INumberFieldValue) => {
              onChange(values.value);
              onPercentChange(values.value);
            }}
            placeholder={placeholder || t('suppliers.fields.keySuppliersInPercentage')}
            type={NUMBER_FORMATS.percent}
            allowNegative={false}
            required
          />
        )}
      />
    </div>
  );
}

export default CostFields;
